import { Container, Stack, Typography } from "@mui/material";
import PickleballDrillDataTable from "../components/pickleballDrill/PickleballDrillDataTable";

export default function PickleballDrillDataPage() {
    return (
        <>
            <title>匹克球訓練數據</title>
            <Container maxWidth="xl">
                <Stack direction="column">
                    <Typography variant="h4" sx={{ mb: 5 }}>
                        匹克球訓練數據
                    </Typography>
                    <PickleballDrillDataTable />
                </Stack>
            </Container>
        </>
    );
}
